import React from "react";
import { companyInfo } from "../../data/companyData";
import "./SaasSections.css";

const infoItems = [
  { label: "Legal Name", value: companyInfo.legalName },
  { label: "Founded", value: companyInfo.founded },
  { label: "Headquarters", value: companyInfo.headquarters },
  { label: "Business Model", value: companyInfo.businessModel },
  { label: "Stage", value: companyInfo.stage },
  {
    label: "Contact",
    value: `${companyInfo.email} · ${companyInfo.phone}`,
  },
];

export default function CompanyInfoSection() {
  return (
    <section className="saas-section company-info-section" id="company-info-section">
      <h2 className="saas-section__title">COMPANY INFORMATION</h2>
      <div className="saas-section__header">
        <p className="saas-section__intro">
          Registered private limited company building AI SaaS products from Hyderabad, India.
        </p>
      </div>
      <div className="company-info-grid">
        {infoItems.map((item) => (
          <div key={item.label} className="company-info-item">
            <div className="company-info-item__label">{item.label}</div>
            <div className="company-info-item__value">{item.value}</div>
          </div>
        ))}
      </div>
      <div className="company-info-legal">
        <span>{companyInfo.cin}</span>
        <span>{companyInfo.gstin}</span>
      </div>
    </section>
  );
}
